import React from 'react';
import {ruleIcon} from '../../../../assets/images/images';
import {ChevronDown, ChevronUp} from 'lucide-react';

export const RuleDetails = ({ruleName, ruleDetails}) => {
  const [isOpen, setIsOpen] = React.useState(true);
  return (
    <div className="ml-7 mt-5 rounded-xl pb-10 lg:mr-8 bg-[#F2F6FD] border border-[#D9E5F8]">
      <div className="py-4 px-6">
        <h4 className="text-deepBlue text-tiny font-semibold mb-2">
          {ruleName || 'N/A'}
        </h4>
        <p className="text-[#5C688E] text-small">
          {ruleDetails?.description || 'N/A'}
        </p>
      </div>
      <div className="border border-y-[#EFEFEF] rounded-b-xl border-transparent bg-white h-[60vh]">
        <div className="py-2 px-6">
          <p className="text-[#344272] text-tiny font-normal">
            {ruleDetails?.intro || 'N/A'}
          </p>
        </div>

        {ruleDetails?.groups?.map((group, index) => (
          <div key={index} className="px-6 flex flex-col gap-4 mt-2">
            <div className="bg-[#EEF3FC] border-[#CED2DD] border py-3 px-4 rounded-lg">
              <div
                className="flex items-center justify-between cursor-pointer"
                onClick={() => setIsOpen(!isOpen)}
              >
                <div className="flex items-center gap-2">
                  <img src={ruleIcon} alt="icon" />

                  <span className="text-tiny font-medium text-[#033971]">
                    {group?.title || 'N/A'}
                  </span>
                </div>
                <button className="focus:outline-none">
                  {isOpen ? (
                    <ChevronUp className="w-5 h-5 fill-black stroke-none" />
                  ) : (
                    <ChevronDown className="w-5 h-5 fill-black stroke-none" />
                  )}
                </button>
              </div>

              {isOpen && (
                <div className="mt-2">
                  <p className="text-small text-[#033971] mb-2">
                    {group?.condition || 'N/A'}
                  </p>
                  {group.rules.map((rule, index) => (
                    <div
                      key={index}
                      className="bg-white border border-[#F0FFFE] border-dashed rounded-lg px-2 py-2 flex flex-col mb-3"
                    >
                      <div className="flex items-center bg-[#fefefe] relative border lg:max-w-[288px] text-[#858DAA] min-h-[36px] rounded-lg border-[#dce1e9] pr-2 pl-3 py-2 rounded-r-md transition-all duration-200">
                        <div className="flex items-center">
                          <div className="w-[5px] h-full rounded-r-lg absolute bg-brandBlue left-[-1px] rounded-full mr-2"></div>
                          <p className="text-xs capitalize flex items-center gap-2">
                            {rule || 'N/A'}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
